import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    query,
    setDoc,
    where,
    orderBy,
    limit
} from "firebase/firestore";
import {Promise} from "bluebird";
import _ from "lodash";
import {DATA_LIMIT} from "../constants/printful.constant";
import {fireStoreDB} from "../../firebase/client-app";

export {
    addPrintfulProductsPrices,
    addSinglePrintfulProductsPrice,
    updateSinglePrintfulProductsPrice,
    getSinglePrintfulProductsPrice,
    getAllPrintfulProductsPrices,
    searchPrintfulProductsPrices,
    searchPrintfulProductsPricesWithSearchCriteria,
    preparePrintfulProductsPricesList
}

const collectionName = 'printful-products-price';
const collectionReference = collection(fireStoreDB, collectionName);

const addPrintfulProductsPrices = (printfulProductsPrices) => {
    return Promise.map(printfulProductsPrices, async printfulProductsPrice => {
        await addSinglePrintfulProductsPrice(printfulProductsPrice);
    });
}

const addSinglePrintfulProductsPrice = (printfulProductsPrice) => {
    printfulProductsPrice.createdAt = new Date();
    printfulProductsPrice.updatedAt = printfulProductsPrice.createdAt;
    return addDoc(collectionReference, printfulProductsPrice);
}

const updateSinglePrintfulProductsPrice = (printfulProductsPrice) => {
    const documentReference = doc(fireStoreDB, collectionName, printfulProductsPrice.id);
    printfulProductsPrice.updatedAt = new Date();
    return setDoc(documentReference, printfulProductsPrice);
}

const getSinglePrintfulProductsPrice = async (printfulProductsPriceId) => {
    const documentReference = doc(fireStoreDB, collectionName, printfulProductsPriceId);
    const printfulProductsPriceDoc = await getDoc(documentReference);
    return prepareSinglePrintfulProductsPrice(printfulProductsPriceDoc);
}

const getAllPrintfulProductsPrices = async () => {
    let searchQuery = query(collectionReference);
    const printfulProductsPricesResult = await getDocs(searchQuery);
    return preparePrintfulProductsPricesList(printfulProductsPricesResult);
}

const searchPrintfulProductsPrices = async (searchText, perPage = DATA_LIMIT) => {
    let searchQuery = query(collectionReference);

    if (searchText) {
        searchQuery = query(collectionReference, where("textList", "array-contains", searchText));
    }

    searchQuery = query(searchQuery,
        orderBy('updatedAt', 'desc'));

    searchQuery = query(searchQuery, limit(perPage));

    const printfulProductsPriceResult = await getDocs(searchQuery);
    return preparePrintfulProductsPricesList(printfulProductsPriceResult);
}

const searchPrintfulProductsPricesWithSearchCriteria = async (searchCriteriaList, perPage = DATA_LIMIT) => {
    let searchQuery = query(collectionReference);

    // console.log('searchPrintfulProductsPricesWithSearchCriteria', {searchCriteriaList});

    _.forEach(searchCriteriaList, searchCriteria => {
        searchQuery = query(searchQuery,
            where(searchCriteria.field, searchCriteria.condition, searchCriteria.value));
    });

    /*if (searchCriteriaList.length === 0) {
        searchQuery = query(searchQuery, orderBy('updatedAt', 'desc'));
    }*/

    searchQuery = query(searchQuery, limit(perPage));

    const printfulProductsPriceResult = await getDocs(searchQuery);
    return preparePrintfulProductsPricesList(printfulProductsPriceResult);
}

const preparePrintfulProductsPricesList = (printfulProductsPriceResult) => {
    const printfulProductsPricesList = [];

    _.forEach(printfulProductsPriceResult.docs, printfulProductsPriceDoc => {
        printfulProductsPricesList.push(prepareSinglePrintfulProductsPrice(printfulProductsPriceDoc));
    });

    return printfulProductsPricesList;
}


const prepareSinglePrintfulProductsPrice = (printfulProductsPriceDoc) => {
    const printfulProductsPrice = printfulProductsPriceDoc.data();
    printfulProductsPrice.id = printfulProductsPriceDoc.id;
    return printfulProductsPrice;
}
